import api from '../../api/index';
import router from '../../router';
import i18n from '../../i18n';

export default {
  namespaced: true,
  modules   : {},
  state     : {
    auth_cont: {
      user_mail    : '',
      user_password: '',
      remember     : false,
    },
    auth_error   : '',
    user_id      : null,
    valid_flag   : false,
    email_recover: '',
    modal_active : false,
    modal_text   : '',
  },
  mutations: {
    SET_MODAL_RECOVER(state, value) {
      state.modal_active = value;
    },
    SET_USER_ID(state, value) {
      state.user_id = value;
    },
    SET_REMEMBER_ME(state, value) {
      state.auth_cont.remember = value;
    },
    SET_USER_MAIL(state, value) {
      state.auth_cont.user_mail = value;
    },
    SET_EMAIL_RECOVER(state, value) {
      state.email_recover = value;
    },
    SET_USER_PASSWORD(state, value) {
      state.auth_cont.user_password = value;
    },
    SET_VALID_FLAG(state, value) {
      const res = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (res.test(state.auth_cont.user_mail)) {
        state.valid_flag = value;
      } else {
        state.valid_flag = false;
      }
    },
    SET_ERROR(state, value) {
      state.auth_error = value;
    },
  },
  getters: {
    user_mail    : ({auth_cont}) => auth_cont.user_mail,
    user_password: ({auth_cont}) => auth_cont.user_password,
    email_recover: ({email_recover}) => email_recover,
    remember_me  : ({auth_cont}) => auth_cont.remember,
    modal_active : ({modal_active}) => modal_active,
    modal_text   : ({modal_text}) => modal_text,
    user_id      : ({user_id}) => user_id,
    lang         : (state, getters, rootState, rootGetters) => {
      return rootGetters['profile/general/lang'];
    },
    auth_error: ({auth_error}) => auth_error,
  },
  actions: {
    async logoutKeycloak({state}) {
      localStorage.removeItem('user');
      localStorage.removeItem('basket');
      state.user_id = null;
      try {
        const logoutResponse = await api.user.logoutKeycloak();
        window.location.href = logoutResponse.data;
      } catch (err) {
        console.error(err);
      }
    },
    async logout({state}) {
      localStorage.removeItem('user');
      localStorage.removeItem('basket');
      state.user_id = null;
      try {
        const logoutResponse = await api.user.logout();
        window.location.href = logoutResponse.data;
      } catch (err) {
        console.error(err);
      }
    },
    async logoutRedirect({state}) {
      localStorage.removeItem('user');
      localStorage.removeItem('basket');
      state.user_id = null;
      try {
        const logoutResponse = await api.user.logoutRedirect();
        window.location.href = logoutResponse.data;
      } catch (err) {
        console.error(err);
      }
    },
    async get_app_settings({commit}) {
      try {
        const settings = await api.app.get_settings();
        const {current_lang, footer_links, learning_rules} = settings.data;
        i18n.locale = current_lang;
        document.documentElement.setAttribute('lang', current_lang);
        localStorage.setItem('lang', current_lang);
        commit('profile/general/SET_LANG', current_lang, {root: true});
        commit('common/SET_FOOTER_LINKS', footer_links, {root: true});
        commit('common/SET_LEARNING_RULES', learning_rules, {root: true});
      } catch (err) {
        console.error(err);
      }
    },
    async get_load_user({state, dispatch}) {
      try {
        const load_user = await api.user.load_user(state.user_id);
        await dispatch('profile/user/replace', load_user.data, {root: true});
      } catch (err) {
        console.error(err);
      }
    },
    async get_token({getters, commit, dispatch}) {
      const {user_mail, user_password, lang, remember_me} = getters;

      try {
        const res = await api.user.login(user_mail, user_password, lang, remember_me);

        if (res.data.status === 'ERROR') {
          await commit('SET_ERROR', res.data.message);
          return false;
        }

        commit('SET_VALID_FLAG', user_mail);
        commit('SET_ERROR', '');
        commit('SET_USER_ID', res.data);

        await Promise.all([
          dispatch('get_app_settings'),
          dispatch('get_load_user'),
        ]);

        return true;
      } catch (err) {
        console.error(err);
      }
    },
  },
};
